import script from "./StackedBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&setup=true&lang=js"

import "./StackedBarChart.vue?vue&type=style&index=0&id=4cd1164e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd1164e"]])

export default __exports__